
import ReactDOM from 'react-dom/client'
import App from "./App.js"
import './index.css'
import { ChakraProvider } from '@chakra-ui/react'
import { BrowserRouter } from "react-router-dom";
import ChatProvider from './components/Context/ChatProvider.jsx';

ReactDOM.createRoot(document.getElementById('root')).render(
  <ChakraProvider>
  <BrowserRouter>
  <ChatProvider>
      <App/>
  </ChatProvider>
  </BrowserRouter>
</ChakraProvider>
)
